import { APP_BACKGROUND_COLOR, APP_COLOR } from "../../theme";

export const mobileDrawerStyles = {
  img: {
    width: "30%",
    height: "30px",
    margin: "10px 15px 10px 10px",
  } as const,
  outerContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    height: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  } as const,
  closeButtonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  } as const,
  storageDetailsContainer: {
    display: "flex",
    gap: "10px",
    border: "1px solid #26292B",
    padding: "15px",
    borderRadius: "15px",
    marginBottom: "25px",
    ":hover": {
      cursor: "pointer",
    },
  } as const,
  cloudIconContainer: {
    height: "45px",
    width: "45px",
    borderRadius: "50%",
    border: "1px solid #26292B",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: APP_COLOR,
  } as const,
};
